<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Icon from '../icon/Icon.vue';

const emit = defineEmits(['send']);
const message = ref('');
const textareaRef = ref(null);

const adjustHeight = () => {
  if (!textareaRef.value) return;

  // Reset height to auto to get the correct scrollHeight
  textareaRef.value.style.height = 'auto';
  // Set the height to the scrollHeight
  textareaRef.value.style.height = `${textareaRef.value.scrollHeight}px`;
};

const sendMessage = () => {
  if (message.value.trim()) {
    emit('send', message.value);
    message.value = '';
    // Reset textarea height after sending
    nextTick(() => {
      adjustHeight();
    });
  }
};

const handleInput = () => {
  nextTick(adjustHeight);
};

const handleEnterKey = event => {
  if (event.isComposing) return;
  event.preventDefault();
  sendMessage();
};

onMounted(() => {
  nextTick(adjustHeight);
});
</script>

<template>
  <form class="relative" @submit.prevent="sendMessage">
    <textarea
      ref="textareaRef"
      v-model="message"
      :placeholder="$t('POLARIS.COPILOT.SEND_MESSAGE')"
      class="w-full reset-base !mb-0 ltr:pl-4 ltr:pr-12 rtl:pl-12 rtl:pr-4 py-3 rounded-polaris-md border border-solid border-polaris-input bg-transparent dark:bg-polaris-input/30 shadow-sm type-polaris-body text-polaris-foreground placeholder:text-polaris-muted-foreground outline-none focus-visible:border-polaris-ring focus-visible:ring-[3px] focus-visible:ring-polaris-ring/50 transition-[color,box-shadow] resize-none overflow-hidden max-h-[200px]"
      rows="1"
      @input="handleInput"
      @keydown.enter.exact="handleEnterKey"
    />
    <button
      class="absolute ltr:right-1 rtl:left-1 top-1/2 -translate-y-1/2 h-9 w-10 flex items-center justify-center text-polaris-muted-foreground hover:text-polaris-foreground"
      type="submit"
    >
      <Icon icon="i-ph-arrow-up" class="size-4" />
    </button>
  </form>
</template>
